
<ion-list *ngIf="this.options.length > 0">
  <div style="display: flex; flex-direction: row;"  *ngIf="isSearch">
    <ion-input
      class="select-filters"
      label="Buscar"
      label-placement="floating"
      fill="outline"
      [(ngModel)]="search"
      placeholder="
  Ingrese texto"
    ></ion-input>
  </div>
  <div class="content-list">
    <cdk-virtual-scroll-viewport itemSize="30" class="viewport" [style.height.px]="200">
      <ion-item
      *cdkVirtualFor="let  option of options | filterByProperty : 'name' : search"
      
    >
      <ion-checkbox
        [mode]="'md'"
        [disabled]="validateMaxSelected() && !option?.selected"
        [name]="option?.name"
        [(ngModel)]="option.selected"
        (ngModelChange)="updateSelectedOptions()"
        style="margin-right: 10px"
        labelPlacement="end"
        slot="start"
        aria-label="label.name"
      >
        {{ option.name }}
      </ion-checkbox>
    </ion-item>
    </cdk-virtual-scroll-viewport>
    
  </div>
</ion-list>
